import { render, staticRenderFns } from "./CreateLeagueModal.vue?vue&type=template&id=0fae5d45&scoped=true"
import script from "./CreateLeagueModal.vue?vue&type=script&lang=js"
export * from "./CreateLeagueModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fae5d45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fae5d45')) {
      api.createRecord('0fae5d45', component.options)
    } else {
      api.reload('0fae5d45', component.options)
    }
    module.hot.accept("./CreateLeagueModal.vue?vue&type=template&id=0fae5d45&scoped=true", function () {
      api.rerender('0fae5d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/TutorStandBook/components/LeagueAssistant/components/CreateLeagueModal.vue"
export default component.exports